import { render, staticRenderFns } from "./settings_page.vue?vue&type=template&id=1a52c0ae"
import script from "./settings_page.vue?vue&type=script&lang=js"
export * from "./settings_page.vue?vue&type=script&lang=js"
import style0 from "./settings_page.vue?vue&type=style&index=0&id=1a52c0ae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports